export const goToLogin = () =>
  (window.location.href =
    '/customer/account/login/' +
    `?callbackUrl=${encodeURIComponent(
      window.location.pathname + window.location.hash,
    )}`);
